import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { getUniqueParamIdentifier } from 'components/Common/ScheduleRuns/Parameters';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';


const INITIAL_STATE = undefined;

// Converts Flow Run Parameters into a Map object
const mapToScheduleParametersMap = (parameters = []) => (
  parameters.reduce((parametersMap, parameter) => (
    {
      ...parametersMap,
      [getUniqueParamIdentifier(parameter)]: parameter,
    }
  ), {})
);

export const useFetchScheduledRun = ({ crId, scheduleId }) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();
  const [scheduledRun, setScheduledRun] = useState(INITIAL_STATE);

  const {
    isLoading, isError, isSuccess, data,
  } = useQuery(
    ['Cr-Scheduled-Run', orgId, scheduleId, crId],
    async () => axiosInstance.get(flow(orgId).scheduledRun(crId, scheduleId)),
    {
      onSuccess: () => dispatch(showAlert({ message: 'Flow Scheduled Runs fetched successfully.', type: 'success' })),
      retry: false,
      refetchOnWindowFocus: false,
      enabled: scheduleId !== null,
    },
  );

  const resetToInitialState = () => setScheduledRun(INITIAL_STATE);

  useEffect(() => {
    if (isSuccess) {
      const scheduleRun = data.data?.runDetails;
      setScheduledRun({
        ...scheduleRun,
        parameters: mapToScheduleParametersMap(scheduleRun.parameters),
      });
    }
  }, [isSuccess, data]);

  return {
    isLoading, isError, isSuccess, data: scheduledRun, resetState: resetToInitialState,
  };
};
